import React from 'react';
import './Tooltip.scss';

function Tooltip({ currentArea, tooltip, colorCode }) {
  return (
    <div className="tooltip desktop-only" ref={tooltip}>
      <div className={currentArea ? `tooltip__colorKey ${colorCode[currentArea.fips]}` : null} />
      <div className="tooltip__content">
        <p
          className={
            currentArea
              ? currentArea.name.length < 25
                ? 'tooltip__area'
                : 'tooltip__area tooltip__area--small'
              : null
          }
        >
          {currentArea ? currentArea.name : null}
        </p>
        <p className="tooltip__state">{currentArea ? currentArea.state.toUpperCase() : null} </p>
        <div className="tooltip__click">
          <p className="tooltip__click__text">click for details</p>
        </div>
      </div>
    </div>
  );
}

export default Tooltip;
